(() => {
  const selector = '.t4s-widget__pr-price, .t4s-product-price, [data-product-price], .t4s-cart-item-price, .t4s-cart-total, .t4s-mini_cart__price, .t4s-cart_price, .t4s-sticky-atc__price, .t4s-cart__totalPrice, .t4s-minicart-recommendations__item--price';
  function localize(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const original = node.nodeValue;
      const replacement = original.replace(/\b(?:LE|EGP)\s*([0-9][0-9,.]*)/g, '$1 ج.م').replace(/([0-9][0-9,.]*)\s*(?:LE|EGP)\b/g, '$1 ج.م').replace(/ج\.م\s+EGP\b/g, 'ج.م');
      if (replacement !== original) node.nodeValue = replacement;
    }
  }
  function start() {
    const pending = new Set();
    let scheduled = false;
    function collect(node) {
      const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
      if (!element) return;
      const price = element.closest(selector);
      if (price) pending.add(price);
      if (node.nodeType === Node.ELEMENT_NODE) element.querySelectorAll(selector).forEach(item => pending.add(item));
    }
    document.querySelectorAll(selector).forEach(localize);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'characterData') collect(record.target);
        else record.addedNodes.forEach(collect);
      });
      if (scheduled || !pending.size) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        const work = [...pending];
        pending.clear();
        work.forEach(item => { if (item.isConnected) localize(item); });
      });
    }).observe(document.body, { subtree:true, childList:true, characterData:true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
